import React from 'react';
import moment from 'moment';
import get from 'lodash/get';
import find from 'lodash/find';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import {
  offerOrderAmountPath,
  offerOrderTransferPath,
} from '../../Forms/Schemas/baseRrf';
import BaseDetailScreen from '../../BaseDetailScreen';
import Button from '../../Button';
import LabeledRow from '../components/LabeledRow';
import { formatCurrency } from '../../Currency';
import { formatQuantity } from '../..//SecurityDetail/SecurityDetail';
import './styles.css';

// should show payment information
const Component = ({
  bankLinks,
  offer,
  user,
  offerOrderAmount,
  offerOrderTransferFunds,
  onNext,
  isConditional,
}) => {
  const transferBank = find(bankLinks, { bankLinkOid: offerOrderTransferFunds.from });
  let back = {
    label: 'Review Disclosures',
    to: `/invest/${offer.id}/disclosures`,
  };
  let transferDetails;
  if (offerOrderTransferFunds.transferAmount) {
    back = {
      label: 'Edit Transfer',
      to: `/invest/${offer.id}/payment`,
    };

    transferDetails = (
      <div styleName="transferDetails">
        <div styleName="transferReviewBreakTop" />
        <LabeledRow
          label="From"
          value={transferBank.bankName}
          modifiedStyle="addressRow"
        />
        <LabeledRow
          label=""
          value={transferBank.bankAccountNumber}
        />
        <LabeledRow
          label="Transfer Amount"
          value={`${formatCurrency(Number.parseFloat(offerOrderTransferFunds.transferAmount))}`}
        />
        <div styleName="transferReviewBreakBottom" />
      </div>
    );
  }

  return (
    <BaseDetailScreen
      backLabel={back.label}
      backTo={back.to}
      pageHeading="Review Order"
      pageSubheading="Please review the order below before completing the order process."
    >
      <div styleName="reviewOrderHeader">
        {offer.name}
      </div>
      <div styleName="main">
        <LabeledRow
          label="Investor Name"
          value={`${user.identity.firstName} ${user.identity.lastName}`}
        />
        <LabeledRow
          label="Address"
          value={user.identity.primaryAddress.line1}
          modifiedStyle="addressRow"
        />
        <LabeledRow
          label=""
          value={`${user.identity.primaryAddress.city} ${user.identity.primaryAddress.state}, ${user.identity.primaryAddress.zipcode}`}
        />
        <LabeledRow
          label="Date"
          value={moment().format('ll')}
        />
        {
          isConditional ?
            <LabeledRow
              label="Offering Category"
              value={offer.categoryName}
            /> : null
        }
        {
          isConditional ?
            <LabeledRow
              label="Share Range"
              value={`${formatCurrency(offer.minSharePrice)} - ${formatCurrency(offer.maxSharePrice)}`}
            /> :
            <div>
              <LabeledRow
                label="Share Price"
                value={offer.pricePerShare}
                isCurrency
              />
              <LabeledRow
                label="Share Quantity"
                value={formatQuantity(Number.parseFloat(offerOrderAmount.quantity))}
              />
            </div>
        }
        { offerOrderTransferFunds.transferAmount ?
            transferDetails :
            <div styleName="breakLineTotal" />
        }
        <LabeledRow
          label="Total Investment"
          value={Number.parseFloat(offerOrderAmount.requestedDollarAmount)}
          isCurrency
        />
        <div styleName="acknowledge">
          By clicking &quot;Place Order&quot;, I acknowledge the&nbsp;
          <Link
            styleName="disclaimerLink"
            to={`/invest/${offer.id}/terms-and-conditions`}
          >
            terms and conditions.
          </Link>
        </div>
        <div styleName="submitButtonContainer">
          <Button onClick={onNext}>
            Place Order
          </Button>
        </div>
      </div>
    </BaseDetailScreen>
  );
};

Component.displayName = 'ReviewOrder';

Component.defaultProps = {
  investment: {
    totalInvestment: 0.00,
  },
};

const mapStateToProps = state => ({
  bankLinks: get(state, `accountBankLinks.[${state.currentAccount}].data`, []),
  user: state.user.data,
  offerOrderAmount: get(state, offerOrderAmountPath),
  offerOrderTransferFunds: get(state, offerOrderTransferPath),
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/Invest/InvestmentViews/ReviewOrder.js